(() => {
  const root = document.querySelector('[data-rh-about]');
  if (!root || root.dataset.ready) return;
  root.dataset.ready = 'true';
  const tabs = [...root.querySelectorAll('[data-rh-tab]')];
  const panels = [...root.querySelectorAll('[data-rh-panel]')];
  const tablist = root.querySelector('[data-rh-tabs]');
  if (tablist && tabs.length === panels.length && tabs.length) {
    tablist.setAttribute('role', 'tablist');
    tabs.forEach((tab) => {
      tab.id = 'rh-tab-' + tab.dataset.rhTab;
      tab.setAttribute('role', 'tab');
      tab.setAttribute('aria-controls', 'rh-moment-' + tab.dataset.rhTab);
    });
    panels.forEach(panel => {
      panel.setAttribute('role', 'tabpanel');
      panel.setAttribute('aria-labelledby', 'rh-tab-' + panel.dataset.rhPanel);
      panel.tabIndex = 0;
    });
    const select = (key, focus = false) => {
      tabs.forEach(tab => {
        const active = tab.dataset.rhTab === key;
        tab.setAttribute('aria-selected', String(active));
        tab.tabIndex = active ? 0 : -1;
        if (active && focus) tab.focus();
      });
      panels.forEach(panel => { panel.hidden = panel.dataset.rhPanel !== key; });
    };
    tabs.forEach((tab, i) => {
      tab.addEventListener('click', event => { event.preventDefault(); select(tab.dataset.rhTab); });
      tab.addEventListener('keydown', event => {
        let next;
        if (event.key === 'ArrowRight') next = (i + 1) % tabs.length;
        if (event.key === 'ArrowLeft') next = (i + tabs.length - 1) % tabs.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = tabs.length - 1;
        if (event.key === ' ') { event.preventDefault(); select(tab.dataset.rhTab); }
        if (next !== undefined) { event.preventDefault(); select(tabs[next].dataset.rhTab, true); }
      });
    });
    const hashKey = location.hash.replace('#rh-moment-', '');
    select(tabs.some(tab => tab.dataset.rhTab === hashKey) ? hashKey : tabs[0].dataset.rhTab);
    root.classList.add('is-enhanced');
  }
  // Animate on entry without ever hiding content if JavaScript is unavailable.
  const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
  if (!motion.matches && 'IntersectionObserver' in window) {
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('rh-in-view');
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.12 });
    root.querySelectorAll('[data-rh-reveal]').forEach(el => observer.observe(el));
  }
})();
